import config from '../../config';
import APIService from './APIService';
import { objectToQueryParams } from '../helpers/common';
import store from '../store';
const projectSearchUrl = config.baseUrlForProjectSearch;
const searchService = config.searchService;
export default class SearchService extends APIService {
  /**
   * It is used to get archive details y789
   * @param {string} archiveId
   * @param {string} userId
   * @param {string} projectId
   */
  static archiveDetails(archiveId, userId, projectId) {
    let url = `${projectSearchUrl}/v1/archives/${encodeURIComponent(
      archiveId
    )}?user_id=${userId}`;
    if (projectId) {
      url = url + `&project_id=${projectId}`;
    }
    return this.get(url);
  }
  /**
   * To get Archive list
   *
   * @param {string} orgId
   * @param {string} userId
   * @param {string} type
   * @param {string} pageNumber
   * @param {string} pageSize
   * @param {string} sortBy
   * @param {string} sortOrder
   * @param {string} params
   * @param {string} org
   */
  static getArchiveList(
    {
      orgId,
      userId,
      type,
      pageNumber,
      pageSize,
      sortBy,
      sortOrder,
      params,
      org
    },
    cancelToken
  ) {
    let url = projectSearchUrl;
    const queryParams =
      '?' + objectToQueryParams({ pageNumber, pageSize, sortBy, sortOrder });
    if (params) {
      if (org) {
        url = `${url}/search/v1/${orgId}`;
      } else {
        url = `${url}/v1/${orgId}/${userId}/search`;
      }

      return this.post(url + queryParams, params, undefined, cancelToken);
    }
    return this.get(
      `${url}/v1/${orgId}/${userId}/${type}${queryParams}`,
      undefined,
      undefined,
      cancelToken
    );
  }
  /**
   *
   * @param {*} params
   * @param {*} orgId
   */
  static getArchiveCount({ params, orgId }) {
    return this.post(`${projectSearchUrl}/v1/${orgId}/project_create`, params);
  }

  static getEmailVolume() {
    const currentOrgId = store.state.currentlySelectedOrgId;
    return this.get(`${searchService}/email/volume/v1/${currentOrgId}`);
  }
}
